import {FC} from 'react'
import {Navigate, Outlet} from 'react-router-dom'
import {useAuth} from '../modules/auth'
import {AppRole, getInitialRoute} from './roleRouting'

type RoleGuardProps = {
  allowedRoles: AppRole[]
}

const RoleGuard: FC<RoleGuardProps> = ({allowedRoles}) => {
  const {currentUser} = useAuth()

  if (!currentUser) return <Navigate to='/auth' replace />

  if (!currentUser.rol || !allowedRoles.includes(currentUser.rol as AppRole)) {
    return <Navigate to={getInitialRoute(currentUser.rol)} replace />
  }

  return <Outlet />
}

export {RoleGuard}

